import CampaignUpdatePage from "./CampaignUpdatePage"

export default CampaignUpdatePage
